import styled from 'styled-components'

export const BudgetingTag = styled.span`
  padding: 2px 8px;
  background: #4b5563;
  border-radius: 4px;
  font-size: 11px;
  color: #ffffff;
  border: 1px solid #6b7280;
`
